module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/midi-e48f98ae1970a92d6dcab940bbaebb06.svg";